import {Component, Inject, OnInit} from '@angular/core';
import {ContentResponse} from "../interface/contentResponse";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ContentService} from "../service/content.service";
import {ContentType} from "../interface/contentType";
import {TitleCasePipe} from "@angular/common";
import {UserCardContentListService} from "../user-card-content-list/user-card-content-list.service";
import {ContentTypeModel} from "../interface/contentTypeModel";

@Component({
  selector: 'app-user-content',
  templateUrl: './user-content.component.html',
  styleUrls: ['./user-content.component.scss'],
  providers: [TitleCasePipe]
})
export class UserContentComponent implements OnInit {

  contentTypesList: ContentTypeModel [] = []
  initialContentTypesList : ContentTypeModel [] = []
  sortType: ContentType = ContentType.CONTACT;
  message: string | undefined;

  content: ContentResponse[] = [];
  socialMediaContent: ContentResponse[] = [];
  paymentContent: ContentResponse[] = [];
  contactContent: ContentResponse[] = [];
  documentContent: ContentResponse[] = [];
  businessContent: ContentResponse[] = [];

  showMoreContact: boolean = false;
  showMoreSocialMedia: boolean = false;
  showMorePayment: boolean = false;
  showMoreDocument: boolean = false;
  showMoreBusiness: boolean = false;
  documentsCountNum: number | any;
  successAddedNewCard: boolean = false;

  userCardId: bigint

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private contentService: ContentService,
    private dialogRef: MatDialogRef<UserContentComponent>,
    private titleCase: TitleCasePipe
  ) {
    this.userCardId = this.data.userCardId;
  }

  ngOnInit(): void {
    this.documentsCountNum = this.data.userCardContentDocumentCount
    this.loadContent()
    UserCardContentListService.dialogRefSubject.subscribe(dialogRef => {
      if (!dialogRef) return;
      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.successAddedNewCard = true;
          this.updateDocumentCount();
        }
      });
    });

    this.dialogRef.backdropClick().subscribe(() => {
      this.closePopUp();
    })
  }

  updateDocumentCount() {
    this.documentsCountNum = this.content.filter(item => item.contentType === ContentType.DOCUMENT).length;
  }

  scrollToSection(sectionId: ContentType) {
    this.sortType = sectionId
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({behavior: 'smooth'});
    }
  }

  searchType(event: HTMLInputElement) {
    const term = event.value.trim().toLowerCase();
    if (term.length == 0) {
      this.contentTypesList = this.initialContentTypesList
      return;
    }

    const filteredContent = this.content.filter((contentResponse: ContentResponse) => {
      const contentResponseNameLower: string = contentResponse.name.toLowerCase();
      return contentResponseNameLower.includes(term);
    });

    this.contentTypesList = [
      {type: this.transformedSortType, content: filteredContent, showMore: this.currentShowMore}
    ];
  }

  private filterContentByType(contentType: ContentType): ContentResponse[] {
    return this.content.filter((content) => content.contentType === contentType);
  }

  private loadContent() {
    this.contentService.getAllContent().subscribe((content) => {
      this.content = content;
      this.socialMediaContent = this.filterContentByType(ContentType.SOCIAL_MEDIA);
      this.paymentContent = this.filterContentByType(ContentType.PAYMENT);
      this.contactContent = this.filterContentByType(ContentType.CONTACT);
      this.documentContent = this.filterContentByType(ContentType.DOCUMENT);
      this.businessContent = this.filterContentByType(ContentType.BUSINESS);
      this.contentTypesList.push(
        {type: ContentType.CONTACT, content: this.contactContent, showMore: this.showMoreContact},
        {type: ContentType.SOCIAL_MEDIA, content: this.socialMediaContent, showMore: this.showMoreSocialMedia},
        {type: ContentType.PAYMENT, content: this.paymentContent, showMore: this.showMorePayment},
        {type: ContentType.DOCUMENT, content: this.documentContent, showMore: this.showMoreDocument},
        {type: ContentType.BUSINESS, content: this.businessContent, showMore: this.showMoreBusiness},
      )
      this.initialContentTypesList = this.contentTypesList
    });
  }

  closePopUp() {
    this.dialogRef.close()
  }

  get currentShowMore() {
    switch (this.sortType) {
      case ContentType.SOCIAL_MEDIA:
        return this.showMoreSocialMedia;
      case ContentType.PAYMENT:
        return this.showMorePayment;
      case ContentType.DOCUMENT:
        return this.showMoreDocument;
      case ContentType.CONTACT:
        return this.showMoreContact;
      case ContentType.BUSINESS:
        return this.showMoreBusiness;
    }
  }

  get transformedSortType() {
    return this.titleCase.transform(this.sortType.toLowerCase().replaceAll('_', ' '));
  }

  protected readonly ContentType = ContentType;
}
